module.exports = __webpack_public_path__ + "static/media/gm.10b90bbf.svg";